import { render, staticRenderFns } from "./CarouselProduct.vue?vue&type=template&id=51bde2d2&"
import script from "./CarouselProduct.vue?vue&type=script&lang=js&"
export * from "./CarouselProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports